

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Card, Form, FormItem, Option, Select } from 'element-ui';

// gql
import FetchCustomerOrganizations from '@/graphql/queries/FetchCustomerOrganizations.gql';

import { CustomerOrganizationFields } from '@/types/graphql/schemaTypes';
import { SelectOption } from '@/types/types';

@Component({
  apollo: {
    customerOrganizationsOptions: {
      query: FetchCustomerOrganizations,
      debounce: 300,
      prefetch: true,
      variables() {
        return {
          customerOrganizationArgs: { name: this.searchCustomer }
        };
      },
      update(data) {
        return data.customerOrganizations.map(this.formatCustomerOptions);
      }
    }
  },
  components: {
    'el-card': Card,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-option': Option,
    'el-select': Select
  }
})

export default class CustomerDetails extends Vue {
  private searchCustomer = '';
  private customerOrganization: CustomerOrganizationFields | null = null;

  private customerOrganizationsOptions: SelectOption<CustomerOrganizationFields>[] = [];

  private formatCustomerOptions(
    customer: CustomerOrganizationFields
  ): SelectOption<CustomerOrganizationFields> {
    return {
      label: customer.name || '',
      value: customer
    };
  }
}
